









































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { BOverlay } from "bootstrap-vue";
import { callFileUrl } from "@/storage";
import axios from "axios";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

@Component({
  components: {
    BOverlay,
  },
})
export default class AudioPlayer extends Vue {
  @Prop() readonly storageId!: any;
  plyr: Plyr | null = null;
  src = "";
  loading = false;
  @Watch("storageId")
  onStorageIdChanged() {
    this.play();
  }
  async play() {
    this.loading = true;
    try {
      const fileUrl = callFileUrl(this.storageId);
      const { data } = await axios.get(fileUrl, {
        responseType: "blob",
      });
      const blob = new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      this.plyr!.source = {
        type: "audio",
        title: "VOICE NOTE",
        sources: [
          {
            src: url,
            type: "video/webm",
          },
        ],
      };
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  close() {
    this.$emit("close");
  }
  mounted() {
    this.plyr = new Plyr("#plyr", {
      controls: ["play", "progress", "current-time"],
      autoplay: true,
      volume: 1,
      debug: true,
    });
    this.play();
  }
}
